module.exports = __webpack_public_path__ + "img/img41.019e9d75.png";